/**
 * Human-friendly quantity formatting for inventory units: scales across
 * metric boundaries (9400 GRAMS → "9.4 kg", 1400 ML → "1.4 L", 0.05 KG →
 * "50 g") and uses compact lowercase labels. Max 2 decimals.
 */
const UNIT_LABELS: Record<string, string> = {
  KG: 'kg',
  GRAMS: 'g',
  LITRE: 'L',
  ML: 'ml',
  PIECES: 'pcs',
  UNITS: 'units',
};

const round2 = (n: number) => Math.round(n * 100) / 100;

export const formatQuantity = (qty: number, unit: string): string => {
  const u = (unit || '').toUpperCase();
  const abs = Math.abs(qty);
  if (u === 'GRAMS' && abs >= 1000) return `${round2(qty / 1000)} kg`;
  if (u === 'ML' && abs >= 1000) return `${round2(qty / 1000)} L`;
  if (u === 'KG' && abs > 0 && abs < 1) return `${round2(qty * 1000)} g`;
  if (u === 'LITRE' && abs > 0 && abs < 1) return `${round2(qty * 1000)} ml`;
  return `${round2(qty)} ${UNIT_LABELS[u] || unit}`;
};

/** Just the scaled number, no label — for inputs and "X of Y" pairs. */
export const formatQuantityParts = (qty: number, unit: string): { value: number; label: string } => {
  const formatted = formatQuantity(qty, unit);
  const spaceIndex = formatted.lastIndexOf(' ');
  return {
    value: Number(formatted.slice(0, spaceIndex)),
    label: formatted.slice(spaceIndex + 1),
  };
};
